import { render, staticRenderFns } from "./StudentsOfTeacher.vue?vue&type=template&id=18d5404c&"
import script from "./StudentsOfTeacher.vue?vue&type=script&lang=js&"
export * from "./StudentsOfTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports